import { createContext } from 'react';

const DateContext = createContext();

export { DateContext };
